import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../Common/Breadcrumbs";
import { SuccessModal } from "../../../Common/SuccessModal";
import EnrolmentForm from "../EnrolmentForm";
import OfflineEnrolmentForm from "../EnrolmentForm/offline/OfflineEnrolmentForm";
import "../AcademyEnrolments.css";
import "./EnrolmentTypeButtons.css";

type EnrolmentType = "excel" | "offline";

const AddEnrolmentPage: React.FC = () => {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [enrolmentType, setEnrolmentType] = useState<EnrolmentType | null>(null);

  const handleSuccess = () => {
    setShowSuccess(true);
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate("/academy-enrolments");
  };

  const handleTypeChange = (type: EnrolmentType) => {
    setEnrolmentType(type);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <div className="mb-3 mt-4" style={{ padding: "0 15px" }}>
          <Breadcrumbs
            items={[
              { label: "Academy" },
              {
                label: "Enrolments Management",
                onClick: () => navigate("/academy-enrolments"),
              },
              { label: "Add Enrolment", active: true },
            ]}
          />
        </div>

        <div style={{ padding: "0 15px", marginBottom: 20 }}>
          <h2 className="mb-0">Add Enrolment</h2>
          <p className="text-muted mb-0" style={{ fontSize: 13 }}>
            Register a new student to an academy batch.
          </p>
        </div>

        <div style={{ padding: "0 15px 40px" }}>
          {/* Enrolment type selector */}
          <div style={{ marginBottom: 24 }}>
            <p className="text-muted mb-2" style={{ fontSize: 13 }}>
              How would you like to add this enrolment?
            </p>
            <div className="enrolment-type-buttons-container">
              <button
                type="button"
                className={`enrolment-type-button${enrolmentType === "excel" ? " selected" : ""}`}
                onClick={() => handleTypeChange("excel")}
              >
                <div className="enrolment-type-radio-button" />
                <div className="enrolment-type-button-content">
                  <span className="enrolment-type-button-text">Excel</span>
                  <div className="enrolment-type-description">
                    Register via phone search and player selection
                  </div>
                </div>
              </button>
              <button
                type="button"
                className={`enrolment-type-button${enrolmentType === "offline" ? " selected" : ""}`}
                onClick={() => handleTypeChange("offline")}
              >
                <div className="enrolment-type-radio-button" />
                <div className="enrolment-type-button-content">
                  <span className="enrolment-type-button-text">Offline</span>
                  <div className="enrolment-type-description">
                    Register with optional phone or create player directly
                  </div>
                </div>
              </button>
            </div>
          </div>

          {enrolmentType === null && (
            <p className="text-muted" style={{ fontSize: 13 }}>
              <i className="ri-arrow-up-line me-1" />
              Select an enrolment type above to continue.
            </p>
          )}

          {enrolmentType === "excel" && (
            <EnrolmentForm key="excel" mode="add" onSuccess={handleSuccess} />
          )}

          {enrolmentType === "offline" && (
            <OfflineEnrolmentForm key="offline" onSuccess={handleSuccess} />
          )}
        </div>
      </Container>

      <SuccessModal
        show={showSuccess}
        handleClose={handleSuccessClose}
        title="Enrolment Created!"
        message="The enrolment has been successfully created."
        buttonLabel="Go to Enrolments"
      />
    </div>
  );
};

export default AddEnrolmentPage;
